var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnHeart = function SvgIcnHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8625 3.11577C13.1279 2.39613 12.1514 2.00012 11.1125 2.00012C10.0734 2.00012 9.0968 2.39613 8.36196 3.11577L7.99997 3.47045L7.63799 3.11577C6.90337 2.39613 5.92651 2.00012 4.88768 2.00012C3.8489 2.00012 2.87196 2.39613 2.13742 3.11577C0.62086 4.60156 0.62086 7.019 2.13742 8.5042L7.57167 13.8277C7.66052 13.9151 7.77114 13.9686 7.8867 13.9892C7.92546 13.9966 7.96443 14.0001 8.00348 14.0001C8.15721 14.0001 8.3112 13.9427 8.42828 13.8277L13.8625 8.5042C15.3792 7.019 15.3792 4.60156 13.8625 3.11577Z",
    fill: "#FF5B56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35389 4.03275C4.38774 4.1609 4.36945 4.28619 4.31251 4.3889C4.24405 4.51242 4.11834 4.60421 3.95822 4.63005C3.65732 4.67797 3.40448 4.83761 3.26488 5.06755C3.1152 5.32488 3.09418 5.6466 3.21802 6.0104C3.31333 6.29068 3.15603 6.56984 2.87004 6.63587C2.58233 6.70268 2.27366 6.53042 2.17883 6.25157C1.96115 5.61061 1.99899 4.98975 2.30542 4.49346C2.591 4.0244 3.09522 3.70083 3.68821 3.60588C3.98152 3.55896 4.27964 3.75025 4.35389 4.03275Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_heart.3daffee3.svg";
export { ForwardRef as ReactComponent };